const ScreenShareMessageType = {
  JOIN_CODE: 'screen-sharing-join-code',
  CHANNEL_ACTIVE: 'screen-sharing-channel-active',
  ERROR: 'screen-sharing-error',
  STREAM_CONNECTED: 'screen-sharing-stream-connected',
  STREAM_PAUSED: 'screen-sharing-stream-paused',
  STREAM_DISCONNECTED: 'screen-sharing-stream-disconnected'
};

module.exports = ScreenShareMessageType;